import { render } from "./MentionList.vue?vue&type=template&id=aa429d3c"
import script from "./MentionList.vue?vue&type=script&lang=js"
export * from "./MentionList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__